/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonWithZugaengeDto } from '../../models/person-with-zugaenge-dto';

export interface DeleteExterne$Plain$Params {

/**
 * ChipNr der externe Entität die gelöscht werden soll
 */
  chipNr: string;
}

export function deleteExterne$Plain(http: HttpClient, rootUrl: string, params: DeleteExterne$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonWithZugaengeDto>> {
  const rb = new RequestBuilder(rootUrl, deleteExterne$Plain.PATH, 'delete');
  if (params) {
    rb.path('chipNr', params.chipNr, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PersonWithZugaengeDto>;
    })
  );
}

deleteExterne$Plain.PATH = '/v1/personzugaenge/{chipNr}';
